import SidebarContainer from '@efdigital/ll-xceed-v2/components/application/sidebar-container.gts';
import { Spinner } from '@efdigital/ll-xceed-v2/components/application/spinner.gts';
import { pageTitle } from 'ember-page-title';

<template>
  {{pageTitle "Coachee"}}
  <SidebarContainer>
    <:sidebar as |className|>
      <div class={{className}}>
      </div>
    </:sidebar>
    <:content>
      <div class="container py-5">
        <Spinner />
      </div>
    </:content>
  </SidebarContainer>
</template>
